import React from "react";
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { InvoiceStatusTagsProps } from "models/propTypes/invoicePropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { Tags } from "components/common";
import { Grid } from "@mui/material";
import { useInvoiceService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const InvoiceStatusTags: React.FC<InvoiceStatusTagsProps> = (props) => {
  const invoiceService = useInvoiceService();
  const getLabelClass = (status: WintSuperkollAPIModel.InvoiceStatus) => {
    switch (status) {
      case WintSuperkollAPIModel.InvoiceStatus.NotSent:
      case WintSuperkollAPIModel.InvoiceStatus.Cancelled:
        return cssExports.grayTag;
      case WintSuperkollAPIModel.InvoiceStatus.Unpaid:
        return cssExports.blueTag;
      case WintSuperkollAPIModel.InvoiceStatus.OverdueReminderSent:
      case WintSuperkollAPIModel.InvoiceStatus.OverdueReminderNotSent:
      case WintSuperkollAPIModel.InvoiceStatus.Expires:
      case WintSuperkollAPIModel.InvoiceStatus.Collection:
      case WintSuperkollAPIModel.InvoiceStatus.ReminderFeeNotFullyPaid:
        return cssExports.redTag;
      case WintSuperkollAPIModel.InvoiceStatus.Paid:
        return cssExports.greenTag;
      default:
        return cssExports.grayTag;
    }
  };
  const status = (
    <Grid container spacing={1} direction="row" alignItems={"center"} wrap={"nowrap"}>
      <Grid item>{invoiceService.getStateText(props.status)}</Grid>
      {props.status === WintSuperkollAPIModel.InvoiceStatus.OverdueReminderSent ||
      props.status === WintSuperkollAPIModel.InvoiceStatus.OverdueReminderNotSent ? (
        <Grid item>
          <Grid item className={cssExports.reminderInvoicesCountContainer}>
            {props.reminderInvoicesCount}
          </Grid>
        </Grid>
      ) : (
        <></>
      )}
    </Grid>
  );

  return (
    <Grid container direction="row" wrap={"nowrap"} spacing={1}>
      <Grid item>
        <Tags tags={[status]} className={getLabelClass(props.status)} />
      </Grid>

      {props.rut && (
        <Grid item>
          {props.houseWorkApplicationIsFiled ? (
            <Tags
              tags={[LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.Rut)]}
              toolTips={[LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.RutAppliedToolTip)]}
              className={cssExports.greenTag}
            />
          ) : (
            <Tags
              tags={[LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.Rut)]}
              toolTips={[LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.RutNotAppliedToolTip)]}
              className={cssExports.yellowTag}
            />
          )}
        </Grid>
      )}

      {props.rot && (
        <Grid item>
          {props.houseWorkApplicationIsFiled ? (
            <Tags
              tags={[LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.Rot)]}
              toolTips={[LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.RotAppliedToolTip)]}
              className={cssExports.greenTag}
            />
          ) : (
            <Tags
              tags={[LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.Rot)]}
              toolTips={[LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.RotNotAppliedToolTip)]}
              className={cssExports.yellowTag}
            />
          )}
        </Grid>
      )}

      {props.hasUnbookedHouseWorkCases && props.houseWorkApplicationIsFiled && (
        <Grid item>
          <Tags
            tags={[LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.WaitingForSkvPayout)]}
            toolTips={[
              LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.WaitingForSkvPayoutToolTip),
            ]}
            className={cssExports.yellowTag}
          />
        </Grid>
      )}

      {props.creditStatus === WintSuperkollAPIModel.InvoiceCreditStatus.Credit && (
        <Grid item>
          <Tags
            tags={[LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Credit)]}
            className={cssExports.yellowTag}
          />
        </Grid>
      )}
      {props.creditStatus === WintSuperkollAPIModel.InvoiceCreditStatus.Credited && (
        <Grid item>
          <Tags
            tags={[LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Credited)]}
            className={cssExports.yellowTag}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default InvoiceStatusTags;
